import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import store from "./store";
import auxVars from "./aux-vars";
import VueMoment from "vue-moment";
import moment from 'moment';
import MdIcon from "./components/helpers/MdIcon.vue";
import axios from "axios";
import i18nMessages from "./i18n-messages";
import VueI18n from "vue-i18n";
import ScIcon from "./components/helpers/ScIcon";
import router from "./router";
import App from "./App.vue";
import chatProvider from "./components/helpers/helpers-chat";


Vue.config.productionTip = false;
Vue.component("md-icon", MdIcon);
Vue.component("ScIcon", ScIcon);

Vue.use(VueMoment,{moment});
Vue.use(VueI18n);

const i18n = new VueI18n({
	locale: navigator.language,
	messages: i18nMessages
});

const app = new Vue({
	el: "#app",
	render: h => h(App),
	i18n,
	router,
	data: {
		auxVars,
		store,
		chatStarted: false,
		warningProps: {
			message: "",
			loading: false,
			okAction: () => {}
		}
	},
	computed: {
		api() {
			let instance = axios.create({
				baseURL: `${process.env.VUE_APP_API_URL}`,
				// timeout: 1000,
				headers: {}
			});
			if (this.store.state.currentToken) {
				instance.defaults.headers.authorization =
					"Bearer " + this.store.state.currentToken;
			}
			if (this.store.state.currentSystem) {
				instance.defaults.headers[
					"X-SC-TYPE"
				] = this.store.state.currentSystem.type;
				instance.defaults.headers[
					"X-SC-SYSTEM"
				] = this.store.state.currentSystem.system.id;
			}
			return instance;
		},
		currentRoute() {
			return this.store.state.currentRoute;
		},
		currentUser() {
			return this.store.state.currentUser;
		},
		isTransportist(){
			let value = false;
			try{
				if (this.$root.store.state.currentSystem) {
					value = this.$root.store.state.currentSystem.system.isTransportist;
				} 
			}catch(err){
				console.log(err)
				value= false;
			}
			return value;
		}
	},

	mounted() {
		// const authPaths = ['/login','/reset-passwd','/update-passwd']
		// if(this.store.state.currentToken === false && !authPaths.includes(this.store.state.currentRoute)){
		// 	window.location.href = '/login';
		// }
		// // usuario logueado
		// const driverUrls = ['/driver','/driver/new-booking']
		// if(this.store.state.currentUser.accessType === 'driver' && !driverUrls.includes(this.store.state.currentRoute)){
		// 	window.location.href = '/driver';
		// }
	},

	created() {
		if (this.store.state.currentUser.lang) {
			this.setLang(this.store.state.currentUser.lang);
		}
		if (this.store.state.currentUser) {
			this.initChat(this.store.state.currentUser);
		}
	},

	methods: {
		setLang(lang) {
			// console.log(['es','en'].indexOf(lang))
			if (["es", "en"].indexOf(lang) != -1) {
				this.$i18n.locale = lang;
			}
		},
		userCan(permission) {
			return (
				this.store.state.currentUser.permissions.find(
					per => per == permission
				) != null
			);
		},
		showWarning({ message, okAction }) {
			let onOk = okAction || function() {};
			let text = message || "";
			let modalProps = {
				loading: false,
				message: "",
				okAction: () => {},
				setLoading: val => {
					this.warningProps.loading = val;
				}
			};
			this.warningProps = {
				...modalProps,
				...{ message: text, okAction: onOk }
			};
			this.$emit("bv::show::modal", "warning-alert", null);
		},
		showAlert(title, props) {
			let toastTitle = title || "";
			let defaultProps = {
				variant: "success",
				solid: true,
				noCloseButton: true
			};
			this.$bvToast.toast(toastTitle, { ...defaultProps, ...props });
		},
		handleRequestError(error) {
			if (error.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				// console.log(error.response.status)
				if (error.response.status == 401) {
					this.store.clearUser();
					window.location.href = "/login";
					return;
				} else if (error.response.status == 422) {
					let message = "Error!";
					Object.keys(error.response.data).forEach(function(key) {
						message = error.response.data[key][0];
					});
					this.showAlert(message, { variant: "danger" });
				} else if (
					error.response.status === 403 &&
					error.response.data.code === "access_denied"
				) {
					if (
						!this.store.state.currentUser ||
						!this.store.state.currentSystem ||
						!this.store.state.currentToken
					) {
						this.store.clearUser();
						window.location.href = "/login";
					} else {
						this.$router.push("/denied").catch(() => {});
					}
				} else if (error.response.data.error) {
					this.showAlert(error.response.data.error, {
						variant: "danger"
					});
				}
			} else if (error.request) {
				this.showAlert(this.$t("global.serverError"), {
					variant: "danger"
				});
			} else {
				console.log("Error", error.message);
			}
		},
		setRouteEvt(evt) {
			evt.preventDefault();
			if (evt.target.pathname) this.$router.push(evt.target.pathname);
		},
		getParams() {
			const url = window.location.href;
			let params = {};
			let parser = document.createElement("a");
			parser.href = url;
			let query = parser.search.substring(1);
			let vars = query.split("&");
			for (let i = 0; i < vars.length; i++) {
				let pair = vars[i].split("=");
				params[pair[0]] = decodeURIComponent(pair[1]);
			}
			return params;
		},
		initChat(user) {
			if (user && user.accessType !== "driver" && !this.chatStarted && this.store.state.currentRoute!= '/driver' && this.store.state.currentRoute != '/supplier-evidences') {
				chatProvider.identify({
					userId: user.id,
					name: `${user.firstName} ${user.lastName}`,
					email: user.email
				});
				chatProvider.start();

				this.chatStarted = true;
			}
		},
		isEmpty(parametro) {
			if (parametro === undefined || parametro === null) {
				return true; // si es undefined o null, entonces es vacío
			}

			if (typeof parametro === 'string' && parametro.trim() === '') {
				return true; // si es una cadena vacía o solo espacios en blanco, entonces es vacío
			}

			if (Array.isArray(parametro) && parametro.length === 0) {
				return true; // si es un arreglo vacío, entonces es vacío
			}

			if (typeof parametro === 'object' && Object.keys(parametro).length === 0) {
				return true; // si es un objeto vacío, entonces es vacío
			}

			return false; // si no se cumple ninguna de las condiciones anteriores, entonces no es vacío
		},
		getItemFromAuxVarOpts(auxVarName, key) {
			let item = { value: key, text: key, class: "" };
			try {
				item = this.auxVars[auxVarName].find(item => item.value == key);
				if (item === undefined) {
					throw new Error("status not valid");
				}
			} catch (ex) {
				item = { value: key, text: key, class: "" };
				console.log(ex);
			}
			return item;
		},
	},
	watch: {
		currentUser(user) {
			this.setLang(user.lang);
			this.initChat(user);
		}
	}
});

window.addEventListener("popstate", () => {
	app.store.state.currentRoute = window.location.pathname;
});
